import PropTypes from 'prop-types';
import React, { useEffect} from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import logoSymbol from "../../assets/images/subros_logo.svg"

const Header = props => {
  
  function tToggle() {
    let body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }


  useEffect(() => {
    setTimeout(() => {
      tToggle();
    },0)
    
  },[])
  

  let roleName = "";
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header ps-0">
          <div className="d-flex align-items-center">

            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to={`/${roleName}/dashboard`} className="logo logo-dark">
                <span className="logo-sm">
                  <img src={'/subros_logo.png'} alt="" height="22" />
                </span>
              </Link>

              <Link to={`/${roleName}/dashboard`} className="logo logo-light">
                <span className="logo-lg">
                  <img src={'/subros_logo.png'} alt="" height="40" />
                </span>
                <span className="logo-sm">
              <img src={logoSymbol} alt="" height="40" style={{borderBottom:"1px solid white",paddingBottom:"5px"}} />
            </span>
              </Link>
            </div>
          </div>
          <div className="d-flex">

            <NotificationDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
